import { styled } from 'linaria/react';

export const Container = styled.div`
  margin-bottom: var(--space-400);

  @media (--only-mobile) {
    padding: 0;
    border: 0;
    border-radius: 0;
  }
`;

export const ProductsBox = styled.div`
  display: flex;
  flex-direction: column;
`;
